import styled from 'styled-components';

export default styled.h3`
  margin: 0 0 2rem;
  text-align: center;
  font-weight: 500;
`;
